export default __webpack_public_path__ + "static/media/oven.12323c43.svg";